import { getAdvisories } from "../lookups/advisories";
import { ScopeOfWork } from "@/api/williams/scopesOfWork";
import { Warning } from "../../components/alerts";

export function Advisories({ data }: { data: Readonly<ScopeOfWork> }) {
  const advisories = getAdvisories(data);
  return (
    <div className="mt-4">
      {advisories.map((advisory) => (
        <Warning key={advisory}>{advisory}</Warning>
      ))}
    </div>
  );
}
